import { render, staticRenderFns } from "./SBProfile.vue?vue&type=template&id=d5ce3cee"
import script from "./SBProfile.vue?vue&type=script&lang=js"
export * from "./SBProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports